import React from "react";

import { HorizontalItems } from '../../Layout/HorizontalItems.jsx'

export class IzdvojeniTurniriHorizontalItems extends React.Component {

    constructor(props) {
        super(props);
        this.state = { turniri: null };

        var promises = Promise.all([casino.repos.pokerTurniriRepo.list()]);
        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    };

    componentWillUnmount() {
        this.dataPromises.cancel();
    };

    setData = (data) => {
        var [turniri] = data;

        turniri = turniri.map((x) => {
            return {
                sifra: x.sifra,
                naziv: x.naziv,
                bannerUrl: x.bannerUrl.replace('cover-', 'thumb-').replace(/\.jpg$/, '.png'),
                url: '/poker/tournaments/' + x.sifra
            }
        }).filter(x => !!x.sifra.indexOf('nedjeljni')).slice(0, 9);

        this.setState({
            turniri: turniri
        });
    };

    render() {
        return <HorizontalItems items={this.state.turniri} />
    }


}